const typography = {
  htmlFontSize: 10,
  fontFamily: 'Avenir, "Arial Narrow", sans‑serif',
  fontSize: 12
}

export default typography
